<script lang="ts">
  import type { Omraade as Area } from "$lib/types/omraade";
  import { selectAreas } from "$lib/utils/areaUtils";
  import sessionValues, { syncSessionValues } from "$lib/sessionValues";
  import { goto } from "$app/navigation";
  import { page } from "$app/state";
  import { browser } from "$app/environment";

  const getAreaListInfoToStore = (selectedArea?: string, index = 0): undefined | [Area, number] => {
    const area =
      selectedArea &&
      selectAreas.find((x, i) => {
        index = i;
        return x.urlLabel === selectedArea;
      });

    return area ? [area, index] : undefined;
  };

  const storeArea = (area: Area, index: number) => {
    const newHash = index === 0 ? "" : `${area.urlLabel}`;
    const allUrlLabels = selectAreas.map((x) => x.urlLabel).join("|");
    const regexSlug = new RegExp(`/?(${allUrlLabels})/?$`);

    goto(`${page.url.pathname?.replace(regexSlug, "") || ""}/${newHash}`, {
      replaceState: true,
      noScroll: true,
      keepFocus: true,
    });
    syncSessionValues({
      i: area.urlLabel,
    });
  };

  const getStoredArea = (): string | undefined => {
    const allUrlLabels = selectAreas.map((x) => x.urlLabel).join("|");
    const regexSlug = new RegExp(`(${allUrlLabels})/?$`);
    const urlArea =
      (page?.url?.pathname?.match(regexSlug)?.[1] || "").replace(/\/$/, "") || undefined;
    if (urlArea) return urlArea;
    const storageArea = $sessionValues?.i;
    if (storageArea) return storageArea;
  };

  let {
    selectedArea = $bindable(),
    initArea,
    class: classes = "",
  }: {
    // let selectedAreas: string[] = [];
    selectedArea?: string;
    initArea: string;
    class?: string;
  } = $props();
  let newArea: string | undefined = $state(initArea);

  if (initArea) {
    selectedArea = initArea;
  }

  if (browser) {
    const storedSelectedArea = getStoredArea();
    if (storedSelectedArea) newArea = storedSelectedArea;
  }

  $effect(() => {
    if (browser && selectedArea !== newArea) {
      selectedArea = newArea;
      const area = getAreaListInfoToStore(selectedArea);
      if (area) storeArea(area[0], area[1]);
    }
  });
</script>

<ul class="p-0 {classes}">
  {#each selectAreas as area (area.urlLabel)}
    {@const id = `omradevalg-${area.urlLabel}`}
    <li class="block">
      <label
        for={id}
        class="button button-link border-0 rounded-0 px-1 min-w-[3rem] active:no-underline relative"
      >
        <span class="tablet:hidden">
          {area.shortLabel}<span class="hidden landscape:inline">/{area.value}</span>
        </span>
        <span class="hidden tablet:inline">
          {area.label}<span class="hidden laptop:inline">/{area.value}</span>
        </span>
        <input type="radio" {id} name="omradevalg" value={area.urlLabel} bind:group={newArea} />
      </label>
    </li>
  {/each}
</ul>

<style lang="postcss">
  :where(:global(input[type="radio"])) {
    all: unset;
    position: absolute;
    inset: 0;

    &:focus-visible {
      outline: 3px solid var(--focus);
    }
  }

  label.button {
    box-shadow:
      0 1px var(--glod),
      0 3px color-mix(in oklab, black 12.5%, transparent);

    &:has(:global(:checked)) {
      box-shadow: 0 3px var(--primary-strong);
      color: var(--natt);
    }
  }
</style>
